import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

/**
 * ToolCallout - teal-bordered card used inside Relo News articles to drive
 * visitors into the SEO tool funnel (Readiness Score / Cost Calculator /
 * Visa Finder).
 *
 * Pass `variant` to pick the message + destination, or pass explicit
 * `text` + `to` for ad-hoc usage. Renders nothing if neither is provided.
 */
const VARIANTS = {
  visa: {
    text: 'Find your exact visa in 4 questions',
    to: '/mexico-visa-finder',
  },
  cost: {
    text: 'Calculate your exact monthly budget',
    to: '/mexico-cost-of-living-calculator',
  },
  readiness: {
    text: 'Find out your Mexico Readiness Score first',
    to: '/mexico-readiness-score',
  },
};

const ToolCallout = ({ variant, text, to, testId }) => {
  const v = variant ? VARIANTS[variant] : null;
  const label = text || v?.text;
  const href = to || v?.to;
  if (!label || !href) return null;

  return (
    <Link
      to={href}
      data-testid={testId || `tool-callout-${variant || 'custom'}`}
      className="block my-8 rounded-xl border-2 border-[#2CA8A0] bg-white px-5 py-4 hover:bg-[#2CA8A0]/5 transition group not-prose"
    >
      <div className="flex items-center justify-between gap-4">
        <div>
          <p className="font-mono uppercase text-[10px] tracking-[0.18em] text-[#2CA8A0] mb-1">
            Free Mundalo tool
          </p>
          <p className="font-display italic text-xl sm:text-2xl text-[#0A1F2E] leading-tight">
            {label}
          </p>
        </div>
        <ArrowRight className="w-5 h-5 text-[#2CA8A0] shrink-0 group-hover:translate-x-1 transition-transform" />
      </div>
    </Link>
  );
};

export default ToolCallout;
